import { Document } from "@contentful/rich-text-types";
import {
    ComponentParameterEnhancerFunction,
    ComponentEnhancerFunction,
    EnhancerBuilder,
    RootComponentInstance,
    enhance
} from "@uniformdev/canvas";

import {
    getRoadmapFeatures,
    ROADMAP_FEATURES_INITIAL_PAGE_SIZE,
    RoadmapName
} from "../../../uniform/components/roadmap-features/src/client";

import { comparePlansEnhancer } from "./compare-plans-enhancer.ts";
import { tableDataEnhancer } from "./table-data-enhancer.ts";
import { richTextToHTML } from "./utils";

const rtfToHTMLEnhancer: ComponentParameterEnhancerFunction = ({
    parameter
}) => {
    if (typeof parameter === "string") {
        return parameter;
    }

    return richTextToHTML(parameter.value as Document);
};

const customerStoryBodyEnhancer: ComponentParameterEnhancerFunction = ({
    parameter
}) => {
    const result = parameter.value;
    // @ts-ignore
    if (result.storyText) {
        // @ts-ignore
        result.storyText = richTextToHTML(
            // @ts-ignore
            result.storyText as Document
        );
    }

    return result;
};

export interface RoadmapFeaturesParameters {
    roadmapFeaturesLocale: { value: string };
    roadmapName: { value: RoadmapName };
}
export const roadmapFeaturesEnhancer: ComponentEnhancerFunction = async ({
    component
}) => {
    const parameters =
        component.parameters as unknown as RoadmapFeaturesParameters;
    const locale = parameters.roadmapFeaturesLocale.value;
    const roadmapName = parameters.roadmapName?.value ?? "Cloud";

    return getRoadmapFeatures({
        limit: ROADMAP_FEATURES_INITIAL_PAGE_SIZE,
        locale,
        roadmapName
    });
};

export const contentfulEnhancer = new EnhancerBuilder()
    // don't implement for richText param type, as that is Uniform rich text, not Contentful
    .parameterName("story", customerStoryBodyEnhancer)
    .parameterName(
        [
            "richText",
            "feature1RichText",
            "feature2RichText",
            "feature3RichText"
        ],
        rtfToHTMLEnhancer
    )
    // @ts-ignore
    .parameterName("comparePlansData", comparePlansEnhancer)
    // @ts-ignore
    .parameterName("tableData", tableDataEnhancer)
    .component("roadmapFeatures", (builder) => {
        builder.data("data", roadmapFeaturesEnhancer);
    });

export const enhanceComposition = async (
    composition: RootComponentInstance
) => {
    await enhance({
        composition: composition,
        enhancers: contentfulEnhancer,
        context: {}
    });

    return composition;
};
